import React from "react";
import { Table, RaisedButton, FlatButton } from "material-ui";
import { formatPrice } from "../../util";
import { colors as Colors } from "material-ui/styles";

class CountdownText extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      countdownText: this._makeText(props.endTime)
    };
  }

  _makeText(endTime) {
    let delta = endTime - Date.now();

    if (delta <= 0) {
      if (this.props.onTimeExpired) {
        this.props.onTimeExpired();
      }
      return "00:00";
    }

    let minutes = Math.floor(delta / 1000 / 60);
    let seconds = Math.floor(delta / 1000) - minutes * 60;
    let parts = [minutes, seconds];

    return parts.map(p => (p < 10 ? "0" : "") + p.toString()).join(":");
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({
        countdownText: this._makeText(this.props.endTime)
      });
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  render() {
    return <span>{this.state.countdownText}</span>;
  }
}

export default CountdownText;



// WEBPACK FOOTER //
// ./src/app/components/partials/countdown-text.jsx